export { saveHomework, saveHomeworkKeywords } from './saveHomework';
export { submitScore } from './submitScore';
export { getHomeworkInfo, fetchHomeworkInfo } from './getHomeworkInfo';
export { deleteHomework } from './deleteHomework';
export { deleteHomeworkAsync } from './deleteHomework';
export { getHomeworkGesture } from './getHomeworkGesture';
export { getHomeworkGestures } from './getHomeworkGestures';
export { downloadHomework } from './downloadHomework';
export { switchHomeworkShield } from './switchHomeworkShield';
export { switchHomeworkExcellent } from './switchHomeworkExcellent';
export { getAiExpressiveEvalTemp } from './getAiExpressiveEvalTemp';
export { getHomeworkAIKeywords } from './getHomeworkKeywords';
export { saveHomeworkCoachTemp } from './saveHomeworkCoachTemp';
